<template>
    <v-container fluid>
        <v-layout row wrap>
            <v-flex xs12>
                <h1>{{$t('pagesTender.upload.title')}}</h1>
                <div
                    class="help_tip"
                >{{$t('pagesTender.upload.description')}}</div>
            </v-flex>
            <v-flex xs12 py-0>
                <v-divider />
            </v-flex>
        </v-layout>

        <v-layout row wrap>
            <v-flex xs12>
                <loading v-if="!currentStatus === null" />
                <transition name="slide-fade" mode="in-out">
                    <v-layout row wrap v-if="isInitial || isSaving">
                        <v-flex xs12>
                            <form enctype="multipart/form-data" novalidate>
                                <div class="dropbox">
                                    <input
                                        type="file"
                                        accept=".csv"
                                        name="new_tenders"
                                        :disabled="isSaving"
                                        @change="filesChange($event.target.name, $event.target.files)"
                                        class="input-file"
                                    />
                                    <p v-if="isInitial" v-html="$t('pagesTender.upload.moveFileHtml')">
                                        
                                    </p>
                                    <p v-if="isSaving">{{$t('pagesTender.upload.loading')}}</p>
                                    <loading v-if="isSaving" />
                                </div>
                            </form>
                        </v-flex>
                    </v-layout>
                </transition>

                <transition name="slide-fade" mode="in-out">
                    <v-layout row wrap v-if="isProcessing">
                        <v-flex my-5 py-5 xs12 text-center>
                            <h3>{{$t('pagesTender.upload.moveFileHtml', {current: getProcessCount(processCount), count: processSummary.count})}}</h3>
                        </v-flex>
                        <v-flex xs12>
                            <v-progress-linear
                                v-model="processProgress"
                                height="30"
                                color="primary"
                                reactive
                            >
                                <strong>{{ Math.floor(processProgress) }}%</strong>
                            </v-progress-linear>
                        </v-flex>
                    </v-layout>
                </transition>

                <transition name="slide-fade" mode="in-out">
                    <v-layout row wrap v-if="isSuccess">
                        <v-flex xs12 my-5 py-5>
                            <h2 class="text-center my-5 py-5">{{$t('pagesTender.upload.loadSuccess')}}</h2>
                        </v-flex>
                    </v-layout>
                </transition>

                <v-layout row wrap v-if="isFailed">
                    <h1 class="mb-3">{{$t('pagesTender.upload.errorLoadTitle')}}</h1>
                    <p>
                        <a href="javascript:void(0)" @click="tryAgain()">{{$t('pagesTender.upload.again')}}</a>
                    </p>
                    <div v-for="(error, idx) in errors" :key="`error_${idx}`">{{ error }}</div>
                </v-layout>

                <v-layout form__row form__errors row wrap v-if="errors && isWrong">
                    <h2 class="mt-5 mb-2 text-center w100">{{$t('pagesTender.upload.errorLoadTitle')}}</h2>
                    <v-flex xs12>
                        {{$t('pagesTender.upload.errorLoadTitle')}}:
                        <div
                            class="error__row"
                            v-for="(error, idx) in errors"
                            :key="`error_f${idx}`"
                        >{{ error }}</div>
                    </v-flex>
                    <div class="text-center py-5 xs12 w100">
                        <v-btn color="primary" @click="tryAgain()">{{$t('pagesTender.upload.again')}}</v-btn>
                    </div>
                </v-layout>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import { apiCallTrue } from "@/utils/api";
import { uploadTenders } from "@/components/lib/file-upload.service";

const STATUS_INITIAL = 0;
const STATUS_SAVING = 1;
const STATUS_SUCCESS = 2;
const STATUS_FAILED = 3;
const STATUS_WRONG = 4;
const STATUS_PROCESSING = 6;

export default {
    name: "UploadTenders",
    data: () => ({
        errors: null,
        uploadedFiles: [],
        uploadError: null,
        currentStatus: null,
        uploadFieldName: "",
        uploadResult: null,
        processSummary: null,
        processCount: 0
    }),
    methods: {
        tryAgain() {
            this.currentStatus = STATUS_INITIAL;
            this.uploadedFiles = [];
            this.uploadError = null;
            this.errors = null;
        },
        save(formData) {
            this.currentStatus = STATUS_SAVING;
            this.errors = null;
            this.processCount = 0;

            uploadTenders(formData)
                .then(response => {
                    if (
                        response.response &&
                        response.response.data &&
                        response.response.data.result
                    ) {
                        this.currentStatus = STATUS_PROCESSING;
                        this.processSummary = response.response.data.data;
                        setTimeout(() => this.checkProcess(), 2000);
                    }
                    if (response.data && response.data.result) {
                        this.currentStatus = STATUS_PROCESSING;
                        this.processSummary = response.data.data;
                        setTimeout(() => this.checkProcess(), 2000);
                    }
                    if (response.data && !response.data.result) {
                        this.errors = [];
                        this.errors[0] = response.data.message;
                        this.currentStatus = STATUS_WRONG;
                    }
                })
                .catch(response => {
                    if (!response.response.data.result) {
                        this.currentStatus = STATUS_PROCESSING;
                        this.processSummary = response.response.data.data;
                        setTimeout(() => this.checkProcess(), 2000);
                    } else {
                        this.errors = [];
                        this.errors[0] = response.response.data.message;
                        this.currentStatus = STATUS_WRONG;
                    }
                });
        },
        filesChange(fieldName, fileList) {
            if (!fileList.length) return;

            const formData = new FormData();
            formData.append("file", fileList[0]);
            this.save(formData);
        },
        checkProcess() {
            apiCallTrue({
                url: "v1/tenders/import-next"
            })
                .then(response => {
                    if (
                        response.data &&
                        response.data.data &&
                        response.data.data.status
                    ) {
                        switch (response.data.data.status) {
                            case 0:
                            case 10:
                                this.currentStatus = STATUS_PROCESSING;
                                this.processSummary = response.data.data.result;
                                this.processCount =
                                    response.data.data.result.current;
                                setTimeout(() => this.checkProcess(), 2000);
                                break;
                            case 90:
                                this.errors = [];
                                this.errors[0] = response.data.data.result.text;
                                this.currentStatus = STATUS_WRONG;
                                break;
                            case 100:
                                if (this.currentStatus === null) {
                                    this.currentStatus = STATUS_INITIAL;
                                } else {
                                    this.currentStatus = STATUS_SUCCESS;
                                    setTimeout(
                                        () =>
                                            (this.currentStatus = STATUS_INITIAL),
                                        3000
                                    );
                                }
                                break;
                        }
                    } else {
                        this.currentStatus = STATUS_INITIAL;
                    }
                })
                .catch(error => console.log(error, "upload error"));
        },
        getProcessCount(number) {
            return number;
        }
    },

    mounted() {
        this.checkProcess();
    },
    computed: {
        isInitial() {
            return this.currentStatus === STATUS_INITIAL;
        },
        isSaving() {
            return this.currentStatus === STATUS_SAVING;
        },
        isSuccess() {
            return this.currentStatus === STATUS_SUCCESS;
        },
        isFailed() {
            return this.currentStatus === STATUS_FAILED;
        },
        isWrong() {
            return this.currentStatus === STATUS_WRONG;
        },
        isProcessing() {
            return this.currentStatus === STATUS_PROCESSING;
        },
        processProgress() {
            if (this.processCount === 0) {
                return 0;
            } else {
                return (
                    (100 / Number(this.processSummary.count)) *
                    this.processCount
                );
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.v-progress-linear__content {
    text-align: center;
    strong {
        color: #fff;
        line-height: 30px;
    }
}
</style>
